import { motion } from "framer-motion";
import { Reveal, EASE } from "@/components/Reveal";

const CELLS = [
  { no: "Q1", label: "Budget", question: "What was planned?", bar: 100 },
  { no: "Q2", label: "Committed", question: "What is already committed?", bar: 72 },
  { no: "Q3", label: "Actual", question: "What has been spent?", bar: 58 },
  { no: "Q4", label: "Forecast", question: "What will the project finally cost?", bar: 84 },
];

export default function Numbers() {
  return (
    <section id="numbers" data-testid="numbers-section" className="relative border-t border-white/10 bg-[#0a0a0a] py-24 md:py-32">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <Reveal>
          <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
            <div>
              <p className="mb-4 flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.28em] text-[#D4AF37]">
                <span className="h-px w-10 bg-[#B79045]" /> Management View
              </p>
              <h2 className="font-display text-4xl font-medium leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
                Numbers That <em className="italic text-[#D4AF37]">Matter.</em>
              </h2>
            </div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-600">
              Ledger View · Per Project
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 border-l border-t border-white/10 sm:grid-cols-2 lg:grid-cols-4 md:mt-20">
          {CELLS.map((c, i) => (
            <Reveal key={c.no} delay={i * 0.08} className="h-full">
              <div
                data-testid={`number-cell-${c.label.toLowerCase()}`}
                className="group flex h-full flex-col justify-between border-b border-r border-white/10 p-8 transition-colors duration-500 hover:border-[#B79045]/40 hover:bg-[#0f0d09] md:p-10"
              >
                <div>
                  <div className="flex items-center justify-between">
                    <span className="font-mono text-xs text-neutral-600">{c.no}</span>
                    <span className="h-1.5 w-1.5 bg-[#B79045] opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                  </div>
                  <h3 className="mt-8 font-mono text-sm uppercase tracking-[0.25em] text-[#D4AF37]">
                    {c.label}
                  </h3>
                  <p className="mt-3 font-display text-2xl font-medium italic leading-snug text-neutral-200 md:text-[1.7rem]">
                    {c.question}
                  </p>
                </div>
                <div className="mt-10">
                  <div className="h-px w-full bg-white/10">
                    <motion.div
                      initial={{ width: 0 }}
                      whileInView={{ width: `${c.bar}%` }}
                      viewport={{ once: true }}
                      transition={{ duration: 1.4, delay: 0.2 + i * 0.1, ease: EASE }}
                      className="h-px bg-[#B79045]"
                    />
                  </div>
                  <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-600">
                    Tracked · Verified · Reported
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
